import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
const NotFound = () => {
  return (
    <main className="flex flex-row justify-center items-center min-h-screen">
      <div className="bg-[#1E73AE] rounded-3xl shadow-2xl">
        <p className="text-6xl p-52 text-[#ffffff]">404 Page Not Found!</p>
      </div>
    </main>
  );
};
const App = () => {
  return (
    <Router>
      <div style={{ backgroundColor: "#FFFFFF" }}>
        <NavBar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
